import { shallowRef } from "vue";

import type { TenantInheritanceState } from "../composables/useTenantInheritanceState";

export const inheritanceTabStateRef = shallowRef<TenantInheritanceState | null>(null);
